import React, { useEffect, useState } from 'react'
import { trans } from 'sharedKernel/i18n'
import { Loading } from 'components/loading'
import { HubCompanyScoutingCarouselList } from 'domain/feature/hub/company/scouting/FormWrapper/list/index'
import { useGetOpportunities } from 'domain/feature/hub/company/scouting/api/scoutingService'

export const HubCompanyScoutingPage = ({ ...props }): JSX.Element => {
  const { data, isFetching, refetch } = useGetOpportunities()
  const [isDelete, setIsDelete] = useState(false)

  const labels = {
    noContent: trans('Você ainda não possui nenhuma oportunidade'),
    loading: trans('Carregando...')
  }

  useEffect(() => {
    if (isDelete) {
      refetch()
      setIsDelete(false)
    }
  }, [refetch, isDelete])

  const renderResponse = (): JSX.Element => {
    if (isFetching) {
      return <Loading />
    }

    const hasData = data?.rows && data.rows.length > 0

    if (!hasData) {
      return (
        <>
          <HubCompanyScoutingCarouselList 
            scoutingList={[]} 
            setIsDelete={setIsDelete}
            showNoContent={true}
            noContentText={labels.noContent}
            noContentImage="/Oportunidades.svg"
          />
        </>
      )
    }

    const sortedRows = [...(data?.rows ?? [])].sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0
      return dateB - dateA
    })

    return (
      <>
        <HubCompanyScoutingCarouselList scoutingList={sortedRows} setIsDelete={setIsDelete} />
      </>
    )
  }

  return <>{renderResponse()}</>
}